export enum Co2RoleEnum {
  IO = 71,
  CONSUME = 72,
  VCHAIN = 73,
  STORE = 74,
  HUB = 75,
  CLUSTER = 76,
}
